module.exports = __webpack_public_path__ + "img/beverages.6c6d2a31.png";